import { generateSliderSteps } from '@/utils/generateSliderSteps';
import * as baseConfig from '@/config/base-config.json';
import * as config from '@/config/config.json';
import { FinancingLoanType } from '../common';

export const MAX_AGE_LIMIT = 95;
export const MIN_LEASE_REQUIRED = 20;

export const OTHERS_CPF_USAGE_LABEL = {
  PropertyType: 'Property Type',
  PurchaseDetails: 'Purchase Details',
  PurchaseOrValuationPrice: 'Purchase or Valuation Price (Whichever is lower)',
  RemainingLeaseYears: 'Remaining Lease (Years)',
  RemainingLeaseYearsTooltip:
    "CPF cannot be used if the property's remaining lease is less than 20 years at the time of purchase.",
  AgeOfYoungestBuyer: 'Age of Youngest Buyer',
  AgeOfYoungestBuyerTooltip:
    'Applicant must be at least 21 years old to be eligible for a housing loan.',
  NumberOfExistingProperties: 'Number of Existing Properties',
  MaxLoansAndCpfUsage: 'Max Loans & CPF Usage',
  MaximumBankLoan: 'Maximum Bank Loan',
  MaximumHDBLoan: 'Maximum HDB Loan',
  MaximumCpfUsage: 'Maximum CPF Usage',
};

export enum CpfUsagePropertyType {
  HDB = 'HDB',
  PRIVATE_PROPERTY = 'Private Property',
}

export enum NumberOfExistingProperties {
  NoProperty = '0',
  OneProperty = '1',
  TwoPropertyAndMore = '2',
}

export const NUMBER_EXISTING_PROPERTIES = {
  LIST: Object.values(NumberOfExistingProperties).map((value) => {
    return {
      value,
      label: value === NumberOfExistingProperties.TwoPropertyAndMore ? `${value}+` : value,
    };
  }),
};

export const REMAINING_LEASE = {
  LABEL_INPUTS: generateSliderSteps(
    baseConfig.remaining_lease_in_years.min,
    baseConfig.remaining_lease_in_years.max,
    20,
  ),
  DEFAULT: baseConfig.remaining_lease_in_years.default,
  MAX: baseConfig.remaining_lease_in_years.max,
  MIN: baseConfig.remaining_lease_in_years.min,
  STEP: 1,
};

export const YOUNGEST_AGE_FOR_HDB = {
  LABEL_INPUTS: generateSliderSteps(
    baseConfig.youngest_age.min,
    baseConfig.youngest_age.max.hdb_property,
    10,
  ),
  DEFAULT: baseConfig.youngest_age.default,
  MAX: baseConfig.youngest_age.max.hdb_property,
  MIN: baseConfig.youngest_age.min,
  STEP: 1,
};

export const YOUNGEST_AGE_FOR_PRIVATE = {
  LABEL_INPUTS: generateSliderSteps(
    baseConfig.youngest_age.min,
    baseConfig.youngest_age.max.private_property,
    10,
  ),
  DEFAULT: baseConfig.youngest_age.default,
  MAX: baseConfig.youngest_age.max.private_property,
  MIN: baseConfig.youngest_age.min,
  STEP: 1,
};

export const MAX_LTV: Record<NumberOfExistingProperties, Record<FinancingLoanType, number>> = {
  [NumberOfExistingProperties.NoProperty]: {
    [FinancingLoanType.sixtyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.first_loan.upto_65_financing_year,
    [FinancingLoanType.seventyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.first_loan.upto_75_financing_year,
  },
  [NumberOfExistingProperties.OneProperty]: {
    [FinancingLoanType.sixtyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.second_loan.upto_65_financing_year,
    [FinancingLoanType.seventyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.second_loan.upto_75_financing_year,
  },
  [NumberOfExistingProperties.TwoPropertyAndMore]: {
    [FinancingLoanType.sixtyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.third_loan_and_onwards.upto_65_financing_year,
    [FinancingLoanType.seventyFiveYearLoan]:
      config.max_ltv_in_percent.private_residential.third_loan_and_onwards.upto_75_financing_year,
  },
};
